<div class="text-center flex flex-col items-center drop-shadow-lg">
    <div class="w-[30rem] bg-form-background rounded-md pl-10 pr-10 pt-5 pb-5 flex flex-col gap-y-2.5">
        <ng-content></ng-content>
    </div>
</div>
